import { getProductTypeByName } from './productTypes';

export const getSingularProductName = name => {
  const productType = getProductTypeByName(name);
  return productType.name;
};
